<template>
  <div class="dialog-bin-form">
    <el-dialog title="添加升级包" :visible="visible" @open="onDialogOpen" @close="onDialogClose">
      <el-form label-position="top" ref="binForm" :rules="batchAddRules" :model="binForm">

        <el-form-item label="应用名" prop="app_id">
          <el-select
            filterable
            default-first-option
            style="width: 50%;"
            v-model="binForm.app_id"
            placeholder="请选择应用">
            <el-option
              v-for="appInfo in appInfoList"
              :key="appInfo.app_id"
              :label="`${appInfo.app_name}（${appInfo.remarks}）`"
              :value="appInfo.app_id">
            </el-option>
          </el-select>
        </el-form-item>

        <div class="upload-form-item">
          <p>升级包</p>
          <div class="upload">
            <i class="iconfont icon-upload-file" />
              <p>{{ binForm.bin === '' ? '上传固件' : binForm.bin.name  }}</p>
              <input type="file" name="file" ref="upload" @change="onFileUpload($el)">
          </div>
        </div>

        <el-form-item label="版本号" prop="version">
          <el-input v-model="binForm.version"
                    @keyup.enter.native="onFormSubmit"></el-input>
        </el-form-item>

        <el-form-item label="备注（升级包更新内容）" prop="remarks">
          <el-input v-model="binForm.remarks"
                    @keyup.enter.native="onFormSubmit"></el-input>
        </el-form-item>

        <!--<el-form-item label="升级包类型" prop="type">-->
          <!--<el-radio v-model="binForm.type" :label="0">普通版</el-radio>-->
          <!--<el-radio v-model="binForm.type" :label="1">定制版</el-radio>-->
        <!--</el-form-item>-->

        <el-form-item style="display: flex; justify-content: center;">
          <el-button type="danger" @click="onFormSubmit">确定</el-button>
          <el-button @click="onBatchAddCancel">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'DialogBatchAdd',
  props: {
    visible: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      binForm: {
        bin: '',
        app_id: '',
        version: '',
        remarks: ''
        // type: 0
      },
      batchAddRules: {
        app_id: [
          { required: true, message: '请选择应用名', trigger: 'change' }
        ],
        version: [
          { required: true, message: '请输入版本号', trigger: 'blur' }
        ],
        remarks: [
          { required: true, message: '请输入备注（升级包更新内容）', trigger: 'blur' }
        ]
        // type: [
        //   { required: true, message: '请选择升级包类型', trigger: 'change' }
        // ]
      }
    }
  },
  computed: {
    ...mapState('app', [
      'appInfoList'
    ])
  },
  methods: {
    ...mapActions('app', [
      'addBinInfo'
    ]),

    onFileUpload (val) {
      const file = this.$refs['upload'].files[0]

      const filename = file.name.split('.')[0]

      this.binForm.bin = file
      this.binForm.version = parseInt(filename.substring(filename.indexOf('_') + 1, filename.length))
    },

    onDialogOpen () {
    },
    onDialogClose () {
      this.$emit('update:visible', false)
    },
    async onFormSubmit () {
      this.$refs['binForm'].validate(async valid => {
        if (valid) {
          const formData = new FormData()
          formData.append('bin', this.binForm.bin)
          formData.append('app_id', this.binForm.app_id)
          formData.append('version', this.binForm.version)
          formData.append('remarks', this.binForm.remarks)
          // formData.append('type', this.binForm.type)

          this.appInfoList.forEach(row => {
            if (row.app_id === this.binForm.app_id) {
              formData.append('app_name', row.app_name)
            }
          })

          const loading = this.$loading({
            lock: true,
            text: '正在上传...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.8)'
          })

          try {
            await this.addBinInfo(formData)

            loading.close()
            this.$message({
              type: 'success',
              message: '上传成功'
            })

            this.$emit('data-change')
            this.$emit('update:visible', false)
          } catch (err) {
            loading.close()
            this.$message({
              type: 'error',
              message: '上传失败，请检查网络'
            })
            console.log(err)
          }
        } else {
          return false
        }
      })
    },
    onBatchAddCancel () {
      this.$emit('update:visible', false)
      this.$refs['binForm'].resetFields()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/sass/base";

.dialog-bin-form {

  .upload {
    height: 6rem;
    width: 14rem;
    border: 1px dashed #666;
    border-radius: 10px;
    text-align: center;
    display: flex;
    flex-flow: column nowrap;
    padding: 15px 0;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;

    i {
      font-size: 1.4rem;
    }
    p {
      font-size: .8rem;
    }
    input {
      width: 6rem;
      height: 14rem;
      position: absolute;
      opacity: 0;
      margin-top: -15px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/app/DialogBinForm.vue